import { RouteRecordRaw } from 'vue-router';
import publicRoutes from './public';
import privateRoutes from './private';

const routes: Array<RouteRecordRaw> = [...publicRoutes, ...privateRoutes];

export default routes;
